import React, { useEffect, useState } from 'react'
import moment from "moment";
import { getFormattedTime } from "../../helpers/getFormattedTime";
import { Fragment, useId } from "react";
import { Button } from '@/components/ui/button';

const DomesticFlightIndividualItem = ({ flight, array }) => {

  const identity = useId();

  return (
    <Fragment key={"Key_" + identity}>
      <div className="col-span-4 md:col-span-1 mb-2 lg:m-0">
        <div className="flex items-center gap-2">
          <img
            src={flight.AirlineLogo}
            className="w-8 h:8 md:w-12 md:h-12 rounded object-contain"
          />
          <div className="flex flex-col items-start justify-start ">
            <h2 className="font-medium text-sm md:text-md text-muted-foreground md:text-foreground">
              {flight.AirlineName}
            </h2>
          </div>
        </div>
      </div>
      <div className="flex md:items-center md:justify-self-center">
        <div key={flight.DepartureTime} className="md:text-center">
          <p className="font-medium">
            {flight.DepartureTime}
          </p>
          <div className="text-muted-foreground text-xs">
            <span className="text-muted-foreground">{flight.Origin}</span>
          </div>
        </div>
      </div>
      <div className="flex md:items-center md:justify-self-center md:text-center">
        <div key={flight.ArrivalTime}>
          <p className="font-medium">
            {flight.ArrivalTime}
          </p>

          <div className="text-muted-foreground text-xs">
            <span key={flight.Destination}>{flight.Destination}</span>
          </div>
        </div>
      </div>
    </Fragment>
  )
}

export default DomesticFlightIndividualItem
